<template>
  <div class="kt-container kt-container--fluid  kt-grid__item kt-grid__item--fluid">

    <!-- end of row -->

    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-body">
            <b-tabs v-model="tab">
              <b-tab :title="$t('notificationsActions.notificationsactions')">
                <data-table :edit-item="editItem" />
              </b-tab>
              <b-tab  @click="newItem={}" :title="$t('site.add')" >
                <my-form :new-item="newItem" />
              </b-tab>
            </b-tabs>
          </div>
          <!-- end of card body -->
        </div>
        <!-- end of card -->
      </div>
      <!-- end of col -->
    </div>
    <!-- end of row -->
  </div>
</template>

<script>
import DataTableVue from './components/DataTable.vue'
import FormVue from './components/Form.vue'

export default {
  name: 'NotificationsactionsIndex',
  components: {
    'data-table': DataTableVue,
    'my-form': FormVue,
  },
  data() {
    return {
      newItem: {},
       tab: 0,
    }
  },
  methods: {
    editItem(data) {
      this.form = true
      console.log("manaa");
      this.newItem = data.item
      this.tab = 1;
    },
  },
}
</script>
